exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".lp-estimate-qna[data-v-a8868c74]{margin-bottom:12px}.lp-estimate-qna[data-v-a8868c74]:last-child{margin-bottom:0}.form-item[data-v-a8868c74]{overflow-y:auto;height:250px;border:1px solid #ddd;padding:20px}.bid-total-price[data-v-a8868c74]{color:#000;font-size:16px;border-bottom:1px solid #ddd;padding-bottom:10px}.bid-price-info[data-v-a8868c74],.bid-total-price[data-v-a8868c74]{font-weight:700;margin-bottom:16px}.bid-price-info[data-v-a8868c74]{color:#999}", ""]);

// exports
